const trackingParams = {
  testingPurposes: {
    sc_o: 'testing_purposes',
  },
  projobs: {
    sc_o: 'companies_ideal_employer_button',
  },
  brandmanager: {
    sc_o: 'companies_brand_manager_button',
  },
  teampermissions: {
    sc_o: 'companies_team_permissions_button',
  },
  createProfile: {
    sc_o: 'companies_creation_companies_profile_button',
  },
  navigationRecommended: {
    sc_o: 'companies_navigation_recommended',
  },
  navigationManaging: {
    sc_o: 'companies_navigation_managing',
  },
  navigationFollowing: {
    sc_o: 'companies_navigation_following',
  },
  brandmanagerButtonCompanyCard: {
    sc_o: 'companies_brand_manager_button_company_cards',
  },
  manageTeamButtonCompanyCard: {
    sc_o: 'companies_brand_manager_button_company_cards',
  },
};

export { trackingParams };
